/**
 *
 * Asynchronously loads the component for PrintTickets
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PrintTickets = lazyLoad(
  () => import('./index'),
  module => module.PrintTickets,
);
